export default {
    methods: {
        setRouteName(notification_type){
            if(notification_type == "invited_to_quote" || notification_type == "allow_update_bid_request" || notification_type == "reject_update_bid_request" || notification_type == "not_awarded_to_quote"){
                return 'contractor-quote-view';
            }else if(notification_type == "applied_to_quote" || notification_type == "quote_applied_update_request" || notification_type == "quote_bid_resubmitted" || notification_type == "progress_file_submitted"){
                return 'manager-quote-view';
            }else if(notification_type == "awarded_to_quote"){
                return 'contractor-workorder-view';
            }else if(notification_type == "abn_acn_verified" || notification_type == "insurance_verified" || notification_type == "license_verified" || notification_type == "compliance_expiry"){
                return 'contractor-compliance';
            }
        }
    }
}